module.exports = __webpack_public_path__ + "static/media/teatre.a4403505.jpg";